import {useCompanyId} from "../../../core";
import {
  AmVersion,
} from "../../../ps-types";
import {useMemo, useState} from "react";
import {Button as SemanticButton, Icon, Modal} from "semantic-ui-react";
import { getDownloadUrl } from "../../projects/amProject.client";

import "../../../campaigns/ICP4/ICP4SignUpPage.css";
import { downloadFileWithoutExtension } from "../../../ui/utils";

export function AnalysisDetails({versionData, projectId, children, variant}: {versionData: AmVersion | undefined, projectId: string, children: React.ReactNode, variant: "on-btn-click" | "rendered-as-is"}){
    const [showDetails, setShowDetails] = useState(false);
    const companyId = useCompanyId();
  
    const downloadVersion = async () => {
      if(!versionData) return;
      const { versionId } = versionData;
      getDownloadUrl(companyId, projectId, versionId)
        .then(async (res) => {
          return await downloadFileWithoutExtension(res.url);
        });
    }

    const headerContent = useMemo(()=>{
      return <div style={{ display: 'flex', alignItems: 'center' }}>
      <div>
        <h2 style={{ 
          margin: 0, 
          fontSize: '24px', 
          fontWeight: '600', 
          color: 'white',
          lineHeight: '1.3'
        }}>
          Analysis Details
        </h2>
      </div>
    </div>
    }, [])

    const downloadModelButton = useMemo(()=> {
      if(!versionData) return <></>;
      return <div
        style={{ display: 'flex', justifyContent: 'flex-end'}}>
        <SemanticButton style={{marginBottom: '24px', textAlign: 'right'}} onClick={downloadVersion}>Download Excel Model
      </SemanticButton>
      </div>
    }, [versionData])

    if(variant === "on-btn-click"){
      return <>
      <div>
    <SemanticButton
    size="medium"
    style={{
      border: 'none',
      borderRadius: '12px',
      padding: '18px 36px',
      fontSize: '18px',
      fontWeight: '600',
      boxShadow: '0 6px 20px rgba(72, 9, 113, 0.3)',
      transition: 'all 0.2s ease',
      minWidth: '200px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    }}
    onClick={() => setShowDetails(true)}>
    Analysis Details
    <Icon name='line graph' />
    </SemanticButton>
    <Modal
      open={showDetails}
      onClose={() => setShowDetails(false)}
      style={{ 
        borderRadius: '16px',
        overflow: 'hidden'
      }}
    >      
            <Modal.Header style={{ 
          background: 'linear-gradient(135deg, #480971 0%, #6435C9 100%)',
          color: 'white',
          padding: '24px 32px',
          borderBottom: 'none'
        }}>
          {headerContent}
        </Modal.Header>
      <Modal.Content style={{ padding: '32px' }}>
      {downloadModelButton}
      {children}
      </Modal.Content>
      <Modal.Actions style={{ 
        padding: '24px 32px',
        background: '#f8f9fa',
        borderTop: '1px solid #e9ecef'
      }}>
        <SemanticButton 
          onClick={() => setShowDetails(false)}
          style={{ 
            borderRadius: '8px',
            padding: '12px 24px',
            fontSize: '16px',
            fontWeight: '500'
          }}
        >
          Close
        </SemanticButton>
      </Modal.Actions>
    </Modal>
  </div>
      </>
    }

    if(variant === "rendered-as-is"){
      return <>
              <div style={{width: '100%'}}>
                {headerContent}
                <div style={{padding: '0px'}}>
                  {downloadModelButton}
                </div>
              {children}
              </div>
      </>
    }
  }